import React from 'react';

import { Typography } from '@mui/material';
import { Surface } from '@infoods/lifebase-ui';

import classNames from 'classnames';
import classes from './PaperWithTitle.module.scss';

type PaperWithTitleProps = {
  title?: string;
  customTitle?: React.ReactNode;
  content: React.ReactNode;
  hasTopMargin?: boolean;
};

const PaperWithTitle = ({
  title,
  customTitle,
  content,
  hasTopMargin,
}: PaperWithTitleProps) => {
  const containerClasses = classNames(classes.container, {
    [classes.topMargin]: hasTopMargin,
  });

  return (
    <Surface className={containerClasses}>
      <div className={classes.titleContainer}>
        {customTitle ?? <Typography className={classes.title}>{title}</Typography>}
      </div>
      <div className={classes.line} />
      <div className={classes.bodyContainer}>{content}</div>
    </Surface>
  );
};

export { PaperWithTitle };
